import { api } from "../../src/api";
import ActionType from "../../src/utils/customTypes";
import Cookies from 'universal-cookie';
const cookies = new Cookies();

export class AuthService extends api {

    private static classInstance?: AuthService;
        
    constructor(token: string, type: ActionType) {
        super( process.env.REACT_APP_BASE_URL,token);    
    } 
  
    public static getInstance() {
        let token = cookies.get('stkc');
        
        if (!this.classInstance) {
            this.classInstance = new AuthService(token!==undefined?token:'', 'GET');
        }
        
        return this.classInstance;
    }   
   
     
    public login = (data : any) => this.instance.post('/auth/login',data).then(response => {
        if (response) {
           
            return response;
        }
    
    }).catch((error: any) => {
        
        return Promise.reject(error);
    });

    public changeRole = (data : any) => this.instance.post('/auth/update-change-role',data).then(response => {
        if (response) {
            
            return response;
        }
    
    }).catch((error: any) => {
        
        return Promise.reject(error);
    });
    
}